module.exports = __webpack_public_path__ + "static/media/two.5144a116.svg";